import React from 'react';
import Modal from '../../common/Modal';

const QuotaNotifyStatus = ({
  showQuotaStatusModal,
  toggleQuotaStatusModal,
  quotaOpt,
  prevQuotaOpt,
}) => {
  return (
    <Modal
      title='quota-notify-status'
      show={showQuotaStatusModal}
      onClose={toggleQuotaStatusModal}
    >
      <header>
        <h3>Notice</h3>
      </header>
      <div className='content'>
        {prevQuotaOpt && (
          <h4>
            The previous selection will remain{' '}
            {prevQuotaOpt.hidden ? 'hidden' : 'open'} on public forms.
            <br />
            <p className='opt-quota-name'>
              Previous Selection: <i>{prevQuotaOpt.value}</i>
              <br />
              Status:{' '}
              <i className={prevQuotaOpt.hidden ? 'Closed' : 'Open'}>
                {prevQuotaOpt.hidden ? 'Closed' : 'Open'}
              </i>
            </p>
          </h4>
        )}
        {prevQuotaOpt && quotaOpt && <hr />}
        {quotaOpt && (
          <h4>
            The updated selection is shown below:
            <br />
            <p className='opt-quota-name'>
              Selection: <i>{quotaOpt.value}</i>
              <br />
              Status:{' '}
              <i className={quotaOpt.hidden ? 'Closed' : 'Open'}>
                {quotaOpt.hidden ? 'Closed' : 'Open'}
              </i>
            </p>
          </h4>
        )}
        <ul>
          <li>
            Options with a <b>Closed</b> status are hidden on public forms.
          </li>
          <li>The form will become inactive when all options have closed.</li>
          <li>
            If you need to update the status of any option, please submit a
            ticket to IT.
          </li>
        </ul>

        <div className='controls'>
          <button
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              toggleQuotaStatusModal();
            }}
          >
            Okay
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default QuotaNotifyStatus;
